<template>
    <div class="form_flex_wrap loading_top_wrap">
        <div v-if="isLoading" class="loading_bg round_none transparent" style="z-index: 999;">
            <div class="loading_wrap">
                <div class="loading_obj">
                    <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                    </svg>
                </div>
            </div>
        </div>
        <div class="form_flex_title">
            <span class="title">{{ $t('reservation_settings.section_appointment_status_management.title') }}</span>
            <span class="info mgl_auto">{{ $t('reservation_settings.section_appointment_status_management.sub_title') }}</span>
        </div>
        <div class="form_flex_cont">
            <div class="table_top_wrap">
                <b>{{ $t('reservation_settings.section_appointment_status_management.label_appointment_status') }}</b>
                <button class="btn btn_blue_line btn_s mgl_auto" @click="createItem()">＋ {{ $t('common.add') }}</button>
            </div>
            <table class="table2_default rsv_program_set">
                <colgroup>
                    <col width="45">
                    <col width="">
                    <col width="125">
                    <col width="140">
                    <col width="105">
                </colgroup>
                <thead>
                    <tr>
                        <th>{{ $t('reservation_settings.section_appointment_status_management.label_color') }}</th>
                        <th>{{ $t('reservation_settings.section_appointment_status_management.label_appointment_status') }}</th>
                        <th>{{ $t('reservation_settings.section_appointment_status_management.label_display_as_visit') }}</th>
                        <th>{{ $t('reservation_settings.section_appointment_status_management.label_change_order') }}</th>
                        <th>{{ $t('common.delete') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <ReservationStatusItem v-for="(item, index) in states" :key="item._id" ref="itemRefs"
                        :item="item"
                        :index="index"
                        :states="states"
                        :basicPalette="basicPalette"
                        @hideColorPalette="hideColorPalette"
                        @updateOrder="updateOrder"
                        @removeItem="removeItem"
                        @updateItem="updateItem"/>
                </tbody>
            </table>
            <small class="red_txt mgt_10" v-if="isShowError">{{ $t('reservation_settings.section_appointment_status_management.placeholder_appointment_status') }}</small>
        </div>
        <div class="btn_wrap">
            <span class="editor_info mgr_auto">{{ modifiedAt }} / {{ modifier }}</span>
            <button class="btn btn_l btn_blue mgl_auto" @click="saveReservationStatus()">
                {{ $t('common.save') }}
            </button>
        </div>
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
const moment = require('@/util/MPMoment')
import { SpaceNavigationAction } from '../Enums/SpaceNavigationAction.js'
import ReservationStatusItem from '../SubViews/ReservationStatusItem.vue'
import { useQueryClient } from '@tanstack/vue-query'
import { v2ReservationStatusListQueryOptions } from '@/composables/queries/v2reservationstatus/use-v2-reservationstatus-find-query'
import { v2ReservationSettingFindOneQueryOptions } from '@/composables/queries/v2reservationsetting/use-v2-reservationsetting-find-one-query'
import { useV2ReservationStatusCreateMutation } from '@/composables/queries/v2reservationstatus/use-v2-reservationstatus-create-mutation'
import { useV2ReservationStatusUpdateMutation } from '@/composables/queries/v2reservationstatus/use-v2-reservationstatus-update-mutation'
import { useV2ReservationStatusRemoveMutation } from '@/composables/queries/v2reservationstatus/use-v2-reservationstatus-remove-mutation'
import { useV2ReservationStatusSendPushMutation } from '@/composables/queries/v2reservationstatus/use-v2-reservationstatus-send-push-mutation'

export default {
    setup() {
        const queryClient = useQueryClient()
        const { mutateAsync: createStatus } = useV2ReservationStatusCreateMutation()
        const { mutateAsync: updateStatus } = useV2ReservationStatusUpdateMutation()
        const { mutateAsync: removeStatus } = useV2ReservationStatusRemoveMutation()
        const { mutateAsync: sendStatusPush } = useV2ReservationStatusSendPushMutation()
        return { queryClient, createStatus, updateStatus, removeStatus, sendStatusPush }
    },
    components: { ReservationStatusItem },
    props: {

    },
    data() {
        return {
            settingValue: undefined,

            originalStates: undefined,
            states: undefined,
            itemsToBeDeleted: [],
            isLoading: false,
            isSaving: false,
            isShowError: false
        }
    },
    watch: {
        originalStates: {
            immediate: true,
            deep: true,
            handler: function(newValue) {
                this.states = deepCopy(newValue)
            }
        }
    },
    computed: {
        modifiedAt: function() {
            if (this.settingValue?.statusModifiedAt == undefined) {
                return '-'
            } else {
                return moment(this.settingValue?.statusModifiedAt).toString(this.$t('common.date_format_YYYY_MM_DD_HH_mm'))
            }
        },
        modifier: function() {
            if (this.settingValue?.statusModifierID == undefined) {
                return '-'
            } else {
                if (this.settingValue.statusModifierID.type >= 3000) {
                    return this.$t('reservation_settings.section_appointment_status_management.label_modified_afterdoc')
                } else {
                    return `${this.settingValue.statusModifierID.realName} ${this.$t('reservation_settings.section_appointment_status_management.label_modified')}`
                }
            }
        },
        basicPalette: function() {
            return this.settingValue?.statusColorPaletteID?.basicPalette ?? []
        }
    },
    mounted() {
        this.requestFetchReservationStatus()
        this.reqeustFetchReservationSetting()
    },
    methods: {
        // 아이템 순서 변경
        updateOrder(action, index) {
            console.log(this.states.length)
            let status = this.states.splice(index, 1)[0]
            switch(action) {
                case SpaceNavigationAction.FIRST:
                    this.states.splice(0, 0, status)
                    break
                case SpaceNavigationAction.PREVIOUS:
                this.states.splice(index - 1, 0, status)
                    break
                case SpaceNavigationAction.NEXT:
                    this.states.splice(index + 1, 0, status)
                    break
                case SpaceNavigationAction.LAST: 
                    this.states.splice(this.states.length, 0, status)
                    break
            }
        },
        // 아이템 추가
        createItem() {
            this.states.push({
                paletteIndex: 0,
                title: '',
                isVisitStatus: false
            })
        },
        // 아이템 변경
        updateItem(item, index) {
            this.states.splice(index, 1, item)
            this.$forceUpdate()
        },
        // 아이템 삭제
        removeItem(index) {
            if (!this.states[index]._id != undefined) {
                this.itemsToBeDeleted.push(this.states[index]._id)
            }
            this.states.splice(index, 1)
        },
        // 팔레트 팝업 숨김
        hideColorPalette(index) {
            let elems = this.$refs.itemRefs
            if (elems == undefined || elems.length == 0) { return }
            for (let i=0 ; i<elems.length ; i++) {
                if (i == index) { continue }
                elems[i].isShowPalette = false
            }
        },
        // 예약상태 저장
        async saveReservationStatus() {
            try {
                if (this.isSaving) { return }

                this.isLoading = true
                this.isSaving = true

                let idx = this.states.findIndex(s => s.title == undefined || s.title == '')
                if (idx != -1) {
                    this.isShowError = true
                    return
                }
                
                for (let i = 0; i < this.itemsToBeDeleted.length; i++) {
                    await this.requestRemoveReservationStatus(this.itemsToBeDeleted[i])
                }
                for (let i = 0; i < this.states.length; i++) {
                    let data = this.states[i]
                    data.sortNum = i
                    await this.requestCreateOrUpdateReservationStatus(data)
                }

                this.requestFetchReservationStatus()
                this.requestUpdateCompletePush()

                this.setToast({
                    isShow: true,
                    text: this.$t('common.label_save_success')
                })

                this.isShowError = false

                this.reqeustFetchReservationSetting()

            } catch (err) {
                console.log('failed to save reservation status' , err)
            } finally {
                this.isLoading = false
                this.isSaving = false
            }
        },
        // 예약상태값 조회
        async requestFetchReservationStatus() {
            try {

                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                this.originalStates = await this.queryClient.fetchQuery(v2ReservationStatusListQueryOptions(this.hospital.selectedHospital._id))
            } catch (err) {
                console.log("reservation status find error" , err)
            }
        },
        // 상태 생성 / 수정
        async requestCreateOrUpdateReservationStatus(status) {
            let data = status
            if (data._id == undefined || data._id == '') {
                data = {
                    hospitalID: this.hospital.selectedHospital._id,
                    title: data.title,
                    isVisitStatus: data.isVisitStatus,
                    isCancelStatus: false,
                    paletteIndex: data.paletteIndex,
                    sortNum: data.sortNum
                }
                await this.createStatus(data)
            } else {
                await this.updateStatus(data)
            }
        },

        // 상태 삭제
        async requestRemoveReservationStatus(id) {
            let data = { _id: id }
            await this.removeStatus(data)
        },
        // 변경완료 푸시
        requestUpdateCompletePush() {
            // 기존과 동일하게 fire-and-forget — 실패는 로그만
            this.sendStatusPush({ hospitalID: this.hospital.selectedHospital._id }).catch(() => console.log('push send fail'))
        },
        // 예약설정 조회
        async reqeustFetchReservationSetting() {
            try {
                this.isLoading = true
                let param = {
                    hospitalID: this.hospital.selectedHospital._id,
                }
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                this.settingValue = await this.queryClient.fetchQuery(v2ReservationSettingFindOneQueryOptions(param))
            } catch (err) {
                console.log('reservation setting find error from display method component ', err)
            } finally {
                this.isLoading = false
            }
        },

    }
}
</script>